
import React, { useContext, useEffect, useState } from 'react';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useNavigate } from 'react-router-dom';
import SignUpForm from './SignUpForm.js';
import { Login_customer, Login_forgotPassword } from './services/context_state_management/actions/action.js';
import { SignInContext } from './services/contexts/SignInContext.js';
import axios from 'axios';

const SignInForm = ({ onSignIn }) => {
  const { dispatch } = useContext(SignInContext);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    otp: ''
  });
  const [showSignUpModal, setShowSignUpModal] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  // const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState('');
  const [forgotPasswordStep, setForgotPasswordStep] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user data is stored in localStorage to maintain session after refresh
    const storedUserData = JSON.parse(localStorage.getItem('userData'));
    if (storedUserData) {
      onSignIn(storedUserData);
      // If the user is an admin, redirect to the dashboard
      if (storedUserData.isAdmin) {
        navigate('/dashboard');
      } else {
        setError('You are not authorized to access the dashboard.');
      }
    }
  }, [onSignIn, navigate]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [id]: value
    }));
  };

  const handleSendOtp = async () => {
    setError('');
    try {
      await axios.post(`${process.env.REACT_APP_ADMIN_API_URL}/api/customer/checkcustomer`, { email: formData.email });
      const response = await axios.post(`${process.env.REACT_APP_ADMIN_API_URL}/api/customer/send-otp`, { email: formData.email });
      setError(response.data.message);
      setForgotPasswordStep(2);
    } catch (error) {
      setError(error.response?.data?.error || 'An error occurred while sending OTP');
    }
  };

  const handleVerifyOtp = async () => {
    setError('');
    try {
      const response = await axios.post(`${process.env.REACT_APP_ADMIN_API_URL}/api/customer/verify-otp`, { email: formData.email, otp: formData.otp });
      setError(response.data.message);
      setForgotPasswordStep(3);
    } catch (error) {
      setError(error.response?.data?.error || 'An error occurred while verifying OTP');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      if (forgotPassword) {
        if (forgotPasswordStep === 1) {
          await handleSendOtp();
        } else if (forgotPasswordStep === 2) {
          await handleVerifyOtp();
        } else if (forgotPasswordStep === 3) {
          if (formData.password !== formData.confirmPassword) {
            setError('Passwords do not match');
            return;
          }
          await Login_forgotPassword(formData.email, formData.password, formData.confirmPassword, dispatch);
        }
      } else {
        const response = await Login_customer(formData.email, formData.password, dispatch);
        console.log("inform",response)
        if (response.success) {
          // Store user data in localStorage to persist session
          localStorage.setItem('userData', JSON.stringify(response));
           console.log("we are here");
          if (response.isAdmin) {
            navigate('/dashboard');
          } else {
            setError('You are not authorized to access the dashboard.');
          }
        } else {
          setError(response.message || 'Login failed. Please try again.');
        }
      }
    } catch (error) {
      setError(error.response?.data?.message || 'An unexpected error occurred');
    }
  };

  const resetForm = () => {
    setFormData({
      email: '',
      password: '',
      confirmPassword: '',
      otp: ''
    });
    setError('');
    setForgotPasswordStep(1);
  };

  const toggleForgotPassword = () => {
    setForgotPassword(!forgotPassword);
    resetForm();
  };

  const renderCarousel = () => (
    <div className="h-40 bg-blue-300 border-back-200 mb-4 overflow-hidden">
      <Carousel 
        autoPlay 
        infiniteLoop 
        showThumbs={false} 
        showStatus={false}
        interval={3000}
      >
        {[1, 2, 3].map((_, index) => (
          <div key={index}>
            <img 
              src={`https://images.unsplash.com/photo-1490818387583-1baba5e638af?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwzNjUyOXwwfDF8c2VhcmNofDd8fGZvb2R8ZW58MHx8fHwxNjE2NzI2NDUz&ixlib=rb-1.2.1&q=80&w=400`} 
              alt={`Food ${index + 1}`} 
              className="object-cover h-40 w-full"
              onError={(e) => console.error(`Error loading image: ${e.target.src}`)}
            />
          </div>
        ))}
      </Carousel>
    </div>
  );

  const renderInputField = (id, type, placeholder, value, showToggle = false) => (
    <div className="mb-4 relative">
      <input
        type={showToggle ? (showPassword ? 'text' : 'password') : type}
        id={id}
        placeholder={placeholder}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
        value={value}
        onChange={handleInputChange}
        required
      />
      {showToggle && (
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute inset-y-0 right-0 flex items-center pr-3"
        >
          <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
        </button>
      )}
    </div>
  );

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      {showSignUpModal ? (
        <SignUpForm 
          closeModal={() => setShowSignUpModal(false)}
          onSignUp={(data) => {
            onSignIn(data);
            setShowSignUpModal(false);
          }}
        />
      ) : (
        <div className="w-full max-w-md bg-white rounded-lg shadow-md p-8">
          {renderCarousel()}

          <h2 className="text-2xl font-bold mb-6 text-center">MeraCrackers</h2>

          <form onSubmit={handleSubmit}>
            {!forgotPassword && (
              <>
                {renderInputField('email', 'email', 'Enter email', formData.email)}
                {renderInputField('password', 'password', 'Enter password', formData.password, true)}
              </>
            )}

            {forgotPassword && (
              <>
                {forgotPasswordStep === 1 && renderInputField('email', 'email', 'Enter email for OTP', formData.email)}
                {forgotPasswordStep === 2 && renderInputField('otp', 'text', 'Enter OTP', formData.otp)}
                {forgotPasswordStep === 3 && (
                  <>
                    {renderInputField('password', 'password', 'Enter New Password', formData.password, true)}
                    {renderInputField('confirmPassword', 'password', 'Confirm New Password', formData.confirmPassword, true)}
                  </>
                )}
              </>
            )}

            {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

            <button
              type="submit"
              className="w-full bg-indigo-500 text-white py-2 rounded-md hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              {forgotPassword ? (forgotPasswordStep === 1 ? 'Send OTP' : forgotPasswordStep === 2 ? 'Verify OTP' : 'Reset Password') : 'Sign In'}
            </button>

            <p className="mt-4 text-center">
              {forgotPassword ? (
                <span>
                  Remembered your password?{' '}
                  <button
                    type="button"
                    className="text-indigo-600 hover:underline focus:outline-none"
                    onClick={toggleForgotPassword}
                  >
                    Back to Sign In
                  </button>
                </span>
              ) : (
                <>
                  Forgot password?{' '}
                  <button
                    type="button"
                    className="text-indigo-600 hover:underline focus:outline-none"
                    onClick={toggleForgotPassword}
                  >
                    Reset here
                  </button>
                </>
              )}
            </p>
          </form>
        </div>
      )}
    </div>
  );
};

export default SignInForm;

